import { LayoutBadge, LayoutBadgeProps } from './layout-badge';
import {
    layoutBorderStyle,
    layoutGridStyle,
    layoutTabStyle
} from './layout.styles.css';
import { fontGroups } from '@zoopla-eng/zds/themes';
import { FC, PropsWithChildren } from 'react';

const Layout: FC<PropsWithChildren<LayoutBadgeProps>> = ({
    type,
    children
}) => {
    return (
        <div className={`${layoutBorderStyle({ type })} ${fontGroups.plate}`}>
            {type ? (
                <div className={layoutTabStyle({ type })}>
                    <LayoutBadge type={type} />
                </div>
            ) : null}
            <div className={layoutGridStyle({ type })}>{children}</div>
        </div>
    );
};

export { Layout };
